import React, { useEffect, useRef, useState } from 'react';
import { useDashboardData } from '../context/DashboardDataContext';
import { useActiveDashboard } from '../context/ActiveDashboardContext';
import SapDashboard from '../dashboards/sap_dashboard';

export default function SAPUsageDashboard() {
  const { publishData }  = useDashboardData();
  const activeKey        = useActiveDashboard();
  const lastData         = useRef(null);
  // forceTick dipakai untuk memaksa SapDashboard re-render & trigger onDataChange
  const [forceTick, setForceTick] = useState(0);

  // Saat dashboard ini menjadi aktif:
  // 1. Jika sudah ada data di ref → republish langsung
  // 2. Jika belum ada → increment forceTick agar SapDashboard remount
  useEffect(() => {
    if (activeKey !== 'sap_usage') return;

    if (lastData.current) {
      // Data sudah ada, publish ulang
      publishData(lastData.current);
    } else {
      // Belum ada data sama sekali — paksa re-render dengan key baru
      setForceTick(t => t + 1);
    }
  }, [activeKey]); // eslint-disable-line

  const handleDataChange = (data) => {
    if (!data || !data.filtered || data.filtered.length === 0) return;

    const payload = {
      type:          'sap_usage',
      rawData:       data.rawData,
      filtered:      data.filtered,
      fileName:      data.fileName,
      activeFilters: data.activeFilters,
      updatedAt:     new Date().toISOString(),
    };

    lastData.current = payload;
    publishData(payload);
  };

  // key={forceTick} → saat forceTick berubah, SapDashboard remount
  // dan useEffect di sap_dashboard.jsx akan jalan ulang dengan data fresh
  return <SapDashboard key={forceTick} onDataChange={handleDataChange} />;
}
